import { forwardRef, useImperativeHandle, type HTMLAttributes } from 'react';
import { cn } from './lib';
import { scrollEdgeClasses, useScrollEdges } from './useScrollEdges';
import './ScrollStrip.css';

/** A row that scrolls sideways and says so: a fade on the edge hiding
 *  more, `data-overflow="shown"` for the lint, nothing else changed. Wear
 *  it where a `div` of chips or tabs used to be. */
export const ScrollStrip = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(function ScrollStrip({ className, children, ...rest }, outer) {
  const { ref, edges, overflow } = useScrollEdges<HTMLDivElement>([children]);
  useImperativeHandle(outer, () => ref.current as HTMLDivElement);
  return (
    <div {...rest} ref={ref} className={cn('mrd-strip', className, scrollEdgeClasses(edges))} data-overflow={overflow}>
      {children}
    </div>
  );
});
